"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (obj, key) { return obj.hasOwnProperty(key); });
//# sourceMappingURL=has.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/has.js
// module id = 660
// module chunks = 37